import cx from "classnames";
import React, { ReactNode } from "react";
import { FieldErrors, FieldValues, UseFormRegister } from "react-hook-form";

import { Icon } from "@/components/elements/Icon/";
import { InputError } from "@/components/elements/InputError";
import { InputLabel } from "@/components/elements/InputLabel";

import styles from "./styles.module.css";

export type InputCheckboxProps = {
  id?: string;
  theme?: "light" | "dark";
  register?: UseFormRegister<FieldValues>;
  name: string;
  label?: string;
  disabled?: boolean;
  errors?: FieldErrors;
  extraCopy?: ReactNode;
  className?: string;
  style?: Record<string, unknown>;
};

export const InputCheckbox = ({
  id,
  name,
  label,
  theme = "light",
  register,
  disabled,
  errors,
  className,
  ...rest
}: InputCheckboxProps) => {
  return (
    <div
      className={cx(className, styles[theme], {
        [styles._disabled]: disabled,
      })}
    >
      <div className={styles.inner}>
        <div className={styles.inputContainer}>
          <input
            type="checkbox"
            className={styles.input}
            disabled={disabled}
            id={id}
            {...register(name)}
            {...rest}
          />
          <div className={styles.checkedIcon}>
            <Icon type="checkmark" label={label} />
          </div>
        </div>
        {label && (
          <div className={styles.labelContainer}>
            <InputLabel className={styles.label} htmlFor={id}>
              {label}
            </InputLabel>
          </div>
        )}
      </div>
      {errors && <InputError errors={errors} inputName={name} />}
    </div>
  );
};
